var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { keyframes } from "styled-components";
import { system } from "styled-system";
import { Box } from "./Box";
var spinAnimation = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n"], ["\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n"])));
export var Loader = styled(Box)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border-radius: 50%;\n  width: 20px;\n  height: 20px;\n  animation: ", " 2s linear infinite;\n  ", "\n  ", "\n"], ["\n  border-radius: 50%;\n  width: 20px;\n  height: 20px;\n  animation: ", " 2s linear infinite;\n  ", "\n  ", "\n"])), spinAnimation, function (_a) {
    var theme = _a.theme;
    return ({
        border: "2px solid ".concat(theme.colors.background),
        borderTop: "2px solid ".concat(theme.colors.link),
    });
}, system({ visibility: true }));
var LoaderWrapper = styled(Box)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: inline-block;\n  position: relative;\n  width: 32px;\n  height: 32px;\n  ", "\n"], ["\n  display: inline-block;\n  position: relative;\n  width: 32px;\n  height: 32px;\n  ", "\n"])), system({ visibility: true }));
var LoaderElement = styled(Box)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  box-sizing: border-box;\n  display: block;\n  position: absolute;\n  width: 26px;\n  height: 26px;\n  margin: 3px;\n  border-radius: 50%;\n  animation: ", " 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;\n  ", "\n"], ["\n  box-sizing: border-box;\n  display: block;\n  position: absolute;\n  width: 26px;\n  height: 26px;\n  margin: 3px;\n  border-radius: 50%;\n  animation: ", " 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;\n  ", "\n"])), spinAnimation, function (_a) {
    var theme = _a.theme, color = _a.color;
    return ({
        border: "3px solid ".concat(color || theme.colors.link),
        borderColor: "".concat(color || theme.colors.link, " transparent transparent transparent"),
    });
});
export var Loader2 = function (_a) {
    var visibility = _a.visibility, color = _a.color;
    return (_jsxs(LoaderWrapper, __assign({ visibility: visibility }, { children: [_jsx(LoaderElement, { color: color, style: { animationDelay: "-0.45s" } }), _jsx(LoaderElement, { color: color, style: { animationDelay: "-0.3s" } }), _jsx(LoaderElement, { color: color, style: { animationDelay: "-0.15s" } })] })));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=Loader.js.map